import { EnumSchema } from '../metadata-schema';

export const Onderwijstype: EnumSchema = {
	"type": "string",
	"title": "Onderwijstype",
	"enum": [
		"Regulier",
		"Speciaal"
	]
};
